<template>
  <div class="h-12 text-gray-700 bg-gray-100 hover:bg-gray-200 hover:text-gray-400">
    <router-link
      :to="link"
      class="w-full h-full flex flex-wrap justify-center content-center items-center"
    >
      <slot></slot>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "NavItem",
  data() {
    return {};
  },
  props: {
    link: {
      type: String,
      default: "/"
    }
  },
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>

<style scoped>
.router-link-active {
  @apply bg-gray-700 text-white;
}
</style>